// extracted by mini-css-extract-plugin
export default {"wrap":"GenericNameDdlOrText_wrap__82BTK","toggle":"GenericNameDdlOrText_toggle__88y2A"};